import type { SlotConfig } from '@/components/atomic/input-v2/types'

import { forwardRef } from 'react'

import { BodySmall, BodySubtext } from '@/components/atomic/text'
import { cn } from '@/utils/shadcn/utils'

interface SlotComponentProps {
  slotProps: SlotConfig
  side: 'left' | 'right'
  size?: 'small' | 'large'
  separatorHeight?: string
}

export const Slot = forwardRef<HTMLDivElement, SlotComponentProps>(
  ({ slotProps, side, size = 'large', separatorHeight = '30px' }, ref) => {
    const { icon, label, showSeparator = true, className } = slotProps

    const isRightSlot = side === 'right'

    const renderedLabel = label ? (
      // biome-ignore lint/style/noNestedTernary: Existing code — enable rule without runtime changes
      size === 'small' ? (
        <BodySubtext color="text-secondary" className={className}>
          {label}
        </BodySubtext>
      ) : (
        <BodySmall color="text-secondary" className={className}>
          {label}
        </BodySmall>
      )
    ) : null

    return (
      <div
        ref={ref}
        className={cn(
          'absolute flex items-center px-3 py-1.5',
          isRightSlot ? 'right-0' : 'left-0',
        )}
      >
        <div className="relative flex items-center justify-center whitespace-nowrap">
          {icon || renderedLabel}
        </div>

        {showSeparator && (
          <div
            className={cn(
              'absolute top-0 bottom-0 m-auto w-[1px] bg-moment-blue-grey-200 dark:bg-moment-blue-grey-1000',
              isRightSlot ? 'left-0' : 'right-0',
            )}
            style={{ height: separatorHeight }}
          />
        )}
      </div>
    )
  },
)

Slot.displayName = 'Slot'
